module.exports = __webpack_public_path__ + "img/album07_33.2fa3b5a5.jpg";